import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=02caecad&scoped=true&"
import script from "./Trip.vue?vue&type=script&lang=js&"
export * from "./Trip.vue?vue&type=script&lang=js&"
import style0 from "./Trip.vue?vue&type=style&index=0&id=02caecad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02caecad",
  null
  
)

export default component.exports